module.exports = __webpack_public_path__ + "img/poster-master-5.d17cd75a.jpg";